<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Intervention</h2>
    </div>
  </div>
  <CriteresRechercheIntervention @rechercher="rechercher"/>
  <ResultatRechercheIntervention :interventions="interventions" :isRechercheDataLoading="isRechercheDataLoading"
                                 @removeInterventionFromList="removeInterventionFromList"/>
</template>

<script>
import CriteresRechercheIntervention from '@/components/pilotage/Intervention/CriteresRechercheIntervention.vue'
import ResultatRechercheIntervention from '@/components/pilotage/Intervention/ResultatRechercheIntervention.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheIntervention,
    ResultatRechercheIntervention
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Intervention");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.rechercher();
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      interventions: [],
      isRechercheDataLoading: false
    }
  },
  methods: {
    rechercher() {
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherInterventionAction").then((res) => {
        this.interventions = res.data;
        this.isRechercheDataLoading = false;
      });
    },
    removeInterventionFromList(cle, nom) {
      this.interventions = this.interventions.filter(current => (current.cle != cle && current.nom != nom))
    }
  }
}
</script>
